import { ImageProcess } from './image-process.model';
/**
 * TODO: Error-handling when input something not base64
 * TODO: Accept `string[]`
 * TODO: Accept `File`
 * TODO: Accept `File[]`
 * TODO: Accept `FileList`
 */
class ImageProcessorService {
    src(base64, options = {}) {
        // Set default values
        if (!options.type) {
            options.type = 'image/jpeg';
        }
        if (!options.jpgQuality) {
            options.jpgQuality = 0.9;
        }
        return new ImageProcess(base64, options);
    }
}
export const imageProcessor = new ImageProcessorService();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2UtcHJvY2Vzc29yLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2ltYWdlLXByb2Nlc3Nvci5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSx1QkFBdUIsQ0FBQztBQUdyRDs7Ozs7O0dBTUc7QUFDSCxNQUFNLHFCQUFxQjtJQUN6QixHQUFHLENBQUMsTUFBYyxFQUFFLFVBQXNCLEVBQUU7UUFDMUMscUJBQXFCO1FBQ3JCLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFO1lBQ2pCLE9BQU8sQ0FBQyxJQUFJLEdBQUcsWUFBWSxDQUFDO1NBQzdCO1FBQ0QsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLEVBQUU7WUFDdkIsT0FBTyxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUM7U0FDMUI7UUFFRCxPQUFPLElBQUksWUFBWSxDQUFDLE1BQU0sRUFBRSxPQUFPLENBQUMsQ0FBQztJQUMzQyxDQUFDO0NBQ0Y7QUFFRCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsSUFBSSxxQkFBcUIsRUFBRSxDQUFDIn0=